'use client';
import { AutocompleteOption, type AutocompleteOptionProps } from '@castlery/fortress';
import { CouponOptionItem } from '../coupon-option-item/coupon-option-item';
import { checkEligible, type CouponItemType } from './helper';

export interface CouponDropdownOptionProps extends AutocompleteOptionProps {
  disabled?: boolean;
  children: React.ReactNode;
}
export const CouponDropdownOption = ({ disabled = false, children, ...rest }: CouponDropdownOptionProps) => {
  return (
    <AutocompleteOption
      {...rest}
      sx={{
        opacity: disabled ? 0.4 : 1,
        border: 'none',
        paddingX: 2,
        paddingY: 1.5,
        overflow: 'hidden',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 0.5,
        '&:not(:last-child)': {
          borderBottom: (theme) => `1px solid ${theme.palette.brand.charcoal[300]}`,
        },
      }}
    >
      {children}
    </AutocompleteOption>
  );
};

export const renderOption = (props: object, option: CouponItemType, state: object) => {
  const eligible = checkEligible({ available: option.available, expired_at: option.expired_at });
  return (
    <CouponDropdownOption {...props} disabled={!eligible}>
      {<CouponOptionItem coupon={option} />}
    </CouponDropdownOption>
  );
};
